<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>用户货币变化曲线</span>
        </div>

        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="日期" prop="title">
            <el-date-picker
              v-model="queryParams.startDate"
              size="mini"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="日期" prop="title">
            <el-date-picker
              v-model="queryParams.endDate"
              size="mini"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="用户ID" prop="title">
            <el-input v-model.number="queryParams.uid" size="mini" placeholder="请输入用户ID" @keyup.enter.native="handleQuery" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" :loading="loading" size="mini" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>

        <userRecordStatChart ref="data1" :typ="14" />
        <userRecordStatChart ref="data2" :typ="15" />
        <userRecordStatChart ref="data3" :typ="65" />
        <userRecordStatChart ref="data4" :typ="22" />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getRewardType } from '@/api/config/slot'
import userRecordStatChart from '@/views/config/user/components/user-record.vue'
import { getLastDates } from '@/utils'

export default {
  name: 'UserRewardStat',
  components: {
    userRecordStatChart
  },
  data() {
    return {
      queryParams: {
        startDate: '',
        endDate: '',
        uid: ''
      },
      rewardId: [14, 15, 65, 22],
      loading: false,
      total: 0,
      options: [],
      ridType: [],
      tableData: [],
      rewardType: []
    }
  },
  mounted() {

  },
  created() {
    const getUid = this.$route.query.uid
    const getDate = this.$route.query.date
    if (getDate) {
      this.queryParams.startDate = getDate
      this.queryParams.endDate = getDate
    }
    if (getUid > 0) {
      this.queryParams.uid = getUid
    }

    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(3)
      this.queryParams.endDate = getLastDates(0)
    }

    if (this.queryParams.uid && this.queryParams.startDate) {
      this.$nextTick(() => {
        this.handleQuery()
      })
    }
  },
  methods: {
    handleKeyUp() {
      this.getTables()
    },
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }

      if (!this.queryParams.uid) {
        this.msgError('请输入用户ID')
        return
      }

      this.getTables()
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            const id = parseInt(i)
            this.rewardType.push({ 'label': res.data[i], 'value': id })
          }
        }
      })
    },
    getTables() {
      this.loading = true
      this.$refs.data1.refresh(this.queryParams)
      this.$refs.data2.refresh(this.queryParams)
      this.$refs.data3.refresh(this.queryParams)
      this.$refs.data4.refresh(this.queryParams)
      this.loading = false
    },
    getCurrentDate() {
      const today = new Date()
      const year = today.getFullYear()
      const month = today.getMonth() + 1 // 月份是从0开始的，所以要加1
      const day = today.getDate()
      // 格式化日期为 'YYYY-MM-DD'
      return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`
    },
    scientificFormat(row, col, value) {
      if (value === 0) {
        return 0
      } else {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    }
  }
}
</script>

<style scoped>
</style>
